import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import { useState } from 'react';
import { colors } from '../../utils';

export default function PasswordField(props) {
    const {
        classes,
        className = '',
        ...rest
    } = props;

    const [showPassword, setShowPassword] = useState(false);

    return (
        <TextField
            {...rest}
            type={showPassword ? 'text' : 'password'}
            size="medium"
            className={
                (classes.input) + ' ' + className
            }
            InputProps={{
                ...(rest.InputProps ?? {}),
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                            onClick={() => setShowPassword((prev) => !prev)}
                            onMouseDown={(e) => e.preventDefault()}
                            edge="end"
                            tabIndex={-1}
                            sx={{
                                "& .MuiSvgIcon-root": {
                                    color: colors.blueSent,
                                    paddingRight: "10px",
                                },
                            }}
                        >
                            {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                        </IconButton>
                    </InputAdornment>
                ),
            }}
        />
    );
}
